export default __webpack_public_path__ + "static/data_w.7b88a5edb88d010e55bcc3f1377d1e66.png";